<template>
  <div class="data-sidebar-container">
    <div class="data-sidebar-selector mb-1">
      <div class="datasection-export" style="display:inline-flex">
        <div class="brains-btn-download" @click="downloadDataSection('data-sidebar--inner-container')">{{ $t('export') }} <font-awesome-icon icon="download" /></div>
        <div v-if="loading" class="brains-map-loader dataSidebarLoader" />
        <div class="locallevelselector"><localLevelSelector :titulo-visible="true" @genericlevelchange="locallevelchange" /></div>
      </div>
      <div v-if="loading" class="brains-map-loader dataSidebarLoader" />
    </div>
    <div class="data-sidebar--scroll-container">
      <scrollTabsAUX :scroll-container="'data-sidebar-inner-container'" class="data-sidebar--scroll" :class="[{ 'data-sidebar--scroll__almost-full-2' : tabStatus === 'almost-full' }]">
        <scrollTabAUX v-for="(item, index) in allDataCategories" :key="index" :name="$t(item.toLowerCase())" :target-id="item" />
      </scrollTabsAUX>
    </div>
    <div class="data-sidebar--scroll-container">
      <scrollTabs :scroll-container="'data-sidebar-inner-container'" class="data-sidebar--scroll" :class="[{ 'data-sidebar--scroll__almost-full-2' : tabStatus === 'almost-full' }]">
        <scrollTab v-for="(item) in filteredTypo('residentialData')" :key="'resi_' + item.id" :name="getParsedName(item.id, 'residential')" :target-id="'resi_' + item.id" />
        <scrollTab v-for="(item) in filteredTypo('retailData')" :key="'retail_' + item.id" :name="getParsedName(item.id, 'retail')" :target-id="'retail_' + item.id" />
        <scrollTab v-for="(item) in filteredTypo('officeData')" :key="'office_' + item.id" :name="getParsedName(item.id, 'office')" :target-id="'office_' + item.id" />
        <scrollTab v-for="(item) in filteredTypo('industrialData')" :key="'industrial_' + item.id" :name="getParsedName(item.id, 'industrial')" :target-id="'industrial_' + item.id" />
        <scrollTab v-for="(item) in filteredGeneric" :key="'generic_' + item.id" :name="$t(item.id)" :target-id="'generic_' + item.id" />
      </scrollTabs>
    </div>
    <div v-if="!!allData" id="data-sidebar-inner-container" class="data-sidebar--inner-container" :class="[{ 'data-sidebar--iner-container__almost-full' : tabStatus === 'almost-full' }]">
      <dataListEvolVar v-for="(item) in filteredTypo('residentialData')" :id="'resi_' + item.id" :key="'resi_' + item.id" :id-data="'resi_' + item.id" :title="getParsedName(item.id, 'residential')" :qoq-title="$t('qoq-var')" :yoy-title="$t('yoy-var')" :data="item.data" class="mt-2" />
      <dataListEvolVar v-for="(item) in filteredTypo('retailData')" :id="'retail_' + item.id" :key="'retail_' + item.id" :id-data="'retail_' + item.id" :title="getParsedName(item.id, 'retail')" :qoq-title="$t('qoq-var')" :yoy-title="$t('yoy-var')" :data="item.data" class="mt-2" />
      <dataListEvolVar v-for="(item) in filteredTypo('officeData')" :id="'office_' + item.id" :key="'office_' + item.id" :id-data="'office_' + item.id" :title="getParsedName(item.id, 'office')" :qoq-title="$t('qoq-var')" :yoy-title="$t('yoy-var')" :data="item.data" class="mt-2" />
      <dataListEvolVar v-for="(item) in filteredTypo('industrialData')" :id="'industrial_' + item.id" :key="'industrial_' + item.id" :id-data="'industrial_' + item.id" :title="getParsedName(item.id, 'industrial')" :qoq-title="$t('qoq-var')" :yoy-title="$t('yoy-var')" :data="item.data" class="mt-2" />
      <dataListEvolVar v-for="(item) in filteredGeneric" :id="'generic_' + item.id" :key="'generic_' + item.id" :id-data="'generic_' + item.id" :title="$t(item.id)" :qoq-title="$t('qoq-var')" :yoy-title="$t('yoy-var')" :data="item.data" class="mt-2" />
    </div>
  </div>
</template>

<script>
import { _ } from 'vue-underscore'

import scrollTabs from '@/components/designComponents/scrollTabs'
import scrollTab from '@/components/designComponents/scrollTab'
import scrollTabsAUX from '@/components/designComponents/scrollTabsAux'
import scrollTabAUX from '@/components/designComponents/scrollTabAux'

import dataListEvolVar from '@/components/designComponents/dataListEvolVar'
import exportTable from '@/components/mixins/exportTable'
import { mapState } from 'vuex'
import localLevelSelector from '@/components/genericLevelSelector.vue'
export default {
  name: 'DataSidebarTab',
  components: { scrollTabs, scrollTab, dataListEvolVar, scrollTabsAUX, scrollTabAUX, localLevelSelector },
  mixins: [exportTable],
  data: () => ({
    allData: [],
    genericCategories: ['risk_index', 'socioeconomics_index', 'population', 'economy', 'monthly_unemployment', 'annual_unemployment', 'dwellings'],
    typoCategories: ['sale_market', 'sale_trans', 'rent_market', 'net_rent', 'rent_declared', 'brokers', 'brains_index'],
    allDataCategories: ['resi', 'retail', 'office', 'industrial', 'risk_index', 'socioeconomics_index', 'population', 'economy', 'monthly_unemployment', 'annual_unemployment', 'dwellings'],
    loading: false,
    geolevelselected: null
  }),
  computed: {
    ...mapState('location', {
      geolevels: (state) => state.geolevels
      // geolevelselected: (state) => state.geolevelselected
    }),
    ...mapState('user', {
      tabStatus: (state) => state.tabStatus
    }),
    dataSidebarExport: {
      get() {
        return this.$store.state['location'].dataSidebarExport
      },
      set(value) {
        this.$store.dispatch('location/setDataSidebarExport', { value: value })
      }
    },
    filteredGeneric: {
      get() {
        if (this.allData) {
          var res = []
          var group = _.groupBy(this.allData.genericData, 'bloque')
          for (var [key, value] of Object.entries(group)) {
            if (value) {
              res.push({
                id: this.parsedGroupGeneric(parseInt(key)),
                data: value.filter((f) => !!f.dato)
              })
            }
          }
          return res
        }
        return []
      }
    }
  },
  watch: {
    geolevelselected() {
      this.loadData()
    }
  },
  mounted() {
    this.loadData()
  },
  methods: {
    locallevelchange(geolevel) {
      this.geolevelselected = geolevel
    },
    filteredTypo(typo) {
      if (this.allData) {
        var res = []
        var group = _.groupBy(this.allData[typo], 'bloque')
        for (var [key, value] of Object.entries(group)) {
          if (value) {
            res.push({
              id: this.parsedGroup(parseInt(key)),
              data: value
            })
          }
        }
        return res
      }
      return []
    },
    loadData() {
      var vm = this
      if (!vm.geolevelselected) { return }
      vm.loading = true
      vm.$store.dispatch('location/getDataSection', { objectid: vm.geolevelselected.id })
        .then((resp) => {
          vm.allData = resp
          vm.dataSidebarExport = resp
          vm.loading = false
        })
    },
    groupGeneric(group) {
      return _.groupBy(this.allData.genericData, 'bloque')[this.parsedGroupGeneric(group)]
    },
    groupTypos(typo, group) {
      return _.groupBy(this.allData[typo], 'bloque')[this.parsedGroup(group)]
    },
    parsedGroup(group) {
      switch (group) {
        case 1: return 'sale_market'
        case 2: return 'sale_trans'
        case 3: return 'rent_market'
        case 4: return 'net_rent'
        case 5: return 'rent_declared'
        case 6: return 'brokers'
        case 7: return 'brains_index'
        default: return null
      }
    },
    parsedGroupGeneric(group) {
      switch (group) {
        case 1: return 'risk_index'
        case 2: return 'socioeconomics_index'
        case 3: return 'population'
        case 4: return 'economy'
        case 5: return 'monthly_unemployment'
        case 6: return 'annual_unemployment'
        case 7: return 'dwellings'
        case 8: return 'socioeconomics'
        default: return null
      }
    },
    getParsedName(itemName, typo) {
      return this.$t('dataSection.' + itemName) + (' <span class="data-sidebar-typo-light-v2">(' + this.$t(typo) + ')</span>')
    }
  }
}
</script>
<style lang="scss">
.data-sidebar-typo-light {
  font-size: 0.9em;
  color: lightgrey;
  margin-left: 15px;
}

.data-sidebar-typo-light-v2 {
  font-size: 0.9em;
  color: lightgrey;
}

.data-sidebar--iner-container__almost-full {
  flex-wrap: wrap !important;
  flex-direction: initial !important;
  gap: 10px;

  .brains-data-list-container {
    width: 48% !important;
  }
}

.data-sidebar--scroll__almost-full {
  max-width: initial !important;
}

.data-sidebar--scroll__almost-full-2 {
  max-width: 1456px !important;
}
</style>
<style lang="scss" scoped>
.valuationstock-export {
  display: flex;
  align-items: center;
}

.dir-col {
  flex-direction: column;
}

.dataSidebarLoader {
  top: 45px;
}

.locallevelselector {
  margin-left: 50px;
}

.data-sidebar-container {
  background-color: white;
  height: 100%;
  font-family: "Montserrat-Regular",sans-serif;
  flex-direction: column;
  right: 0px;
  width: 100%;

  display: grid;
  grid-template-rows: auto auto minmax(auto, auto);
  grid-template-columns: auto;

  .data-sidebar--inner-container {
    display: flex;
    flex-direction: column;
    width: 100%;
    height: 100%;
    padding-left: 25px;
    padding-right: 25px;
    overflow: auto;
    position: relative;
  }

  .summary--title {
    font-family: 'Montserrat-SemiBold',sans-serif;
    margin-bottom: 10px;
  }
}

.data-sidebar-selector {
  display: flex;
  align-items: center;
  gap: 15px;
  max-width: 300px;
  height: 100%;
}
</style>
